import { render, staticRenderFns } from "./PelatihanDetail.vue?vue&type=template&id=43ab66b6"
import script from "./PelatihanDetail.vue?vue&type=script&lang=js"
export * from "./PelatihanDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports